module.exports = "/images/backgroundMobileLoginDeliveryman.svg";